@if (showWindowDragRegion()) {
  <app-window-drag-region></app-window-drag-region>
}
<app-cookie-consent-banner></app-cookie-consent-banner>
<router-outlet></router-outlet>
<app-meeting-reminder-overlay></app-meeting-reminder-overlay>
@if (tourVisible()) {
  <app-mascot-bubble [onboardingMode]="true"></app-mascot-bubble>
}
@if (handoffGreeting()) {
  <div class="handoff-greeting">
    <app-mascot-bubble
      [message]="handoffGreetingMessage"
      [responses]="handoffGreetingResponses"
      [showExternalOverlay]="true"
      (responseClick)="dismissHandoffGreeting()"></app-mascot-bubble>
  </div>
}
<app-onboarding-wait-screen></app-onboarding-wait-screen>
<app-onboarding-progress-notification></app-onboarding-progress-notification>
<p-toast position="top-right" key="onboarding"></p-toast>
<p-toast position="top-center" key="session-expired"></p-toast>
<p-toast position="top-right" key="roleplay-v2"></p-toast>
<p-toast position="bottom-right" key="app-update">
  <ng-template let-message pTemplate="message">
    <div class="update-toast-container">
      <div class="update-toast-header">
        <i class="pi pi-download update-toast-icon"></i>
        <span class="update-toast-title">{{ message.summary }}</span>
      </div>
      <div class="update-toast-detail">{{ message.detail }}</div>

      @if (updateState() === 'downloading') {
        <div class="progress-bar-container">
          <div class="progress-bar-fill indeterminate-animation"></div>
        </div>
      }

      @if (updateState() === 'ready') {
        <p-button size="small" label="Restart Now" icon="pi pi-refresh" (click)="onRestart()" styleClass="w-full mt-2"> </p-button>
      }
    </div>
  </ng-template>
</p-toast>
